import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
} from "@angular/router";
import { Location } from "@angular/common";
import { AuthenticationService } from "../_services/authentication.service";

@Injectable()
export class AuthGuard implements CanActivate {
  private configObj = { authEndpoint: "", clientId: "", redirectURI: "" };
  private code: string;
  private cachedURL: string;
  private loginProvider: string;

  constructor(
    private router: Router,
    private location: Location,
    private authenticationService: AuthenticationService
  ) {
    const config = localStorage.getItem("authConfig");
    // const provider = localStorage.getItem('provider');
    const cachedURL = localStorage.getItem("cachedurl");
    // const params = new URLSearchParams(this.location.path(false).split('?')[1]);
    // this.code = params.get('code');
    // if (config) {
    //   this.configObj = JSON.parse(config)[provider];
    // }
    // if (provider) {
    //   this.loginProvider = provider;
    // }
    if (cachedURL) {
      this.cachedURL = cachedURL;
    }
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // console.log(localStorage.getItem('currentSmmAccount'));
    // console.log(localStorage.getItem('cachedurl'));
    // console.log(localStorage.getItem('provider'));

    //console.log("gọi canActivate trước")

    let ticket = route.queryParams.ticket;

    if (localStorage.getItem("currentSmmAccount")) {
      // logged in so return true
      const currentSmmData = JSON.parse(localStorage.getItem("currentSmmData"));
      const now = new Date().getTime();
      const isExpTime = currentSmmData.expiredTime < now; //nếu thời gian hết hạn nhỏ hơn hiện tại
      // const isExpTime = true;
      if (isExpTime) {
        this.authenticationService.saveLogLogout();
        //this.router.navigate(['/auth'], {queryParams: {returnUrl: state.url}});
        if (ticket != undefined) {
          this.router.navigate(["/auth"], { queryParams: { ticket: ticket } });
        } else {
          this.router.navigate(["/auth"]);
        }
      }
      return true;
      // } else if (this.code) {
      //   this.authenticationService.socialLogin(this.code, this.configObj.clientId, this.configObj.redirectURI, this.configObj.authEndpoint)
      //     .then(data => {
      //       console.log(data);
      //       this.router.navigate([this.cachedURL]);
      //       return true;
      //     });
    } else {
      // not logged in so redirect to login page with the return url
      //this.router.navigate(['/auth'], {queryParams: {returnUrl: state.url}});
      if (ticket != undefined) {
        this.router.navigate(["/auth"], { queryParams: { ticket: ticket } });
      } else {
        this.router.navigate(["/auth"]);
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth.guard.ts